import React from 'react';

import { cn } from 'shared/lib';

export type StatusBadgeTone = 'info' | 'success' | 'error' | 'warning' | 'accent' | 'dark' | 'neutral';

type StatusBadgeProps = {
  children: React.ReactNode;
  className?: string;
  icon?: React.ReactNode;
  size?: 'small' | 'history' | 'orderDetail';
  tone: StatusBadgeTone;
};

const TONE_CLASS: Record<StatusBadgeTone, string> = {
  info: 'bg-[#E4F2FF] text-[#0084E3]',
  success: 'bg-[#E1FAE7] text-[#3FC35E]',
  error: 'bg-[#FFF3F3] text-[#E83F2E]',
  warning: 'bg-[#FFF6ED] text-[#FF7A00]',
  accent: 'bg-[#F0F0FF] text-[#0900FF]',
  dark: 'bg-[#222222] text-white',
  neutral: 'bg-[#F2F2F2] text-[#717171]',
};

const SIZE_CLASS: Record<NonNullable<StatusBadgeProps['size']>, string> = {
  small: 'gap-1.5 py-[5px] pl-[9px] pr-[11px] text-[16px]',
  history: 'gap-1 px-2 py-1 text-[13px] md:gap-1.5 md:py-[5px] md:pl-[9px] md:pr-[11px] md:text-[16px]',
  orderDetail:
    'gap-1 px-2 py-1 text-[12px] max-[359px]:px-1.5 max-[359px]:text-[11px] md:gap-1.5 md:px-3 md:text-[20px]',
};

export const StatusBadge = ({ children, className, icon, size = 'small', tone }: StatusBadgeProps) => (
  <span
    className={cn(
      'inline-flex w-fit shrink-0 items-center whitespace-nowrap rounded-full font-semibold leading-[1.4]',
      TONE_CLASS[tone],
      SIZE_CLASS[size],
      className,
    )}
  >
    {icon}
    {children}
  </span>
);
